/**
 * `font-family` string for the fallback font for rich text fields.
 *
 * This string should be passed as the first argument when creating a FontFace object for a fallback font. When defined and added to document.fonts, Rich Text Fields will use this fallback font if the primary font family defined on the field is not available in the current environment.
 */
export const FALLBACK_FONT_STRING = 'FALLBACK_FONT';
